import { render, staticRenderFns } from "./ExpertCatchUp.vue?vue&type=template&id=6a88ad34&scoped=true&"
import script from "./ExpertCatchUp.vue?vue&type=script&lang=js&"
export * from "./ExpertCatchUp.vue?vue&type=script&lang=js&"
import style0 from "./ExpertCatchUp.vue?vue&type=style&index=0&id=6a88ad34&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a88ad34",
  null
  
)

export default component.exports